import { render, staticRenderFns } from "./SupplierSettings.vue?vue&type=template&id=55c1cfc6"
import script from "./SupplierSettings.vue?vue&type=script&lang=js"
export * from "./SupplierSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports